import { render, staticRenderFns } from "./PrazoPagamentoModal.vue?vue&type=template&id=09f63e0c&scoped=true"
import script from "./PrazoPagamentoModal.vue?vue&type=script&lang=js"
export * from "./PrazoPagamentoModal.vue?vue&type=script&lang=js"
import style0 from "./PrazoPagamentoModal.vue?vue&type=style&index=0&id=09f63e0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f63e0c",
  null
  
)

export default component.exports